module.exports = __webpack_public_path__ + "img/services-active.e01fc501.svg";